/* ============================================================
   PALM & CHROME — theme.js
   Shopify-connected JS for the complete storefront
   ============================================================ */

'use strict';

/* ─── 1. Hero canvas animation ─────────────────────────────── */
(function initCanvas() {
  const canvas = document.getElementById('heroCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  let W, H, particles = [];

  function resize() {
    W = canvas.width  = canvas.offsetWidth;
    H = canvas.height = canvas.offsetHeight;
  }

  function Particle() {
    this.reset();
  }
  Particle.prototype.reset = function () {
    this.x  = Math.random() * W;
    this.y  = Math.random() * H;
    this.vx = (Math.random() - .5) * .4;
    this.vy = (Math.random() - .5) * .4;
    this.r  = Math.random() * 1.5 + .5;
    this.a  = Math.random() * .5 + .1;
  };
  Particle.prototype.update = function () {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x < 0 || this.x > W || this.y < 0 || this.y > H) this.reset();
  };

  function init() {
    resize();
    particles = Array.from({ length: 80 }, () => new Particle());
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    particles.forEach(p => {
      p.update();
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255,122,26,${p.a})`;
      ctx.fill();
    });
    // Draw connecting lines
    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        const dx = particles[i].x - particles[j].x;
        const dy = particles[i].y - particles[j].y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 100) {
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.strokeStyle = `rgba(255,122,26,${(1 - dist / 100) * .15})`;
          ctx.lineWidth = .6;
          ctx.stroke();
        }
      }
    }
    requestAnimationFrame(draw);
  }

  window.addEventListener('resize', resize);
  init();
  draw();
})();


/* ─── 2. Gallery switcher ───────────────────────────────────── */
function galSwitch(btn) {
  const thumbs = btn.closest('.gal-thumbs');
  if (!thumbs) return;
  thumbs.querySelectorAll('.gal-thumb').forEach(t => t.classList.remove('on'));
  btn.classList.add('on');
  const mainImg = document.getElementById('gal-img');
  if (mainImg) {
    // data-src contains the 800px URL set directly in Liquid — no regex needed
    const src = btn.dataset.src || btn.querySelector('img')?.src;
    if (src) mainImg.src = src;
  }
}


/* ─── 3. Variant / size / color selectors ───────────────────── */
function sel(btn, group) {
  const row = btn.closest('.' + group + '-row') || btn.closest('[role="group"]');
  if (!row) return;
  row.querySelectorAll('.' + group).forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
}


/* ─── 4. Shopify variant selection ─────────────────────────── */
(function initVariants() {
  // selectedOptions mirrors option index → chosen value
  window._selectedOptions = {};

  window.selectVariantOption = function (btn) {
    const group = btn.closest('[role="group"]');
    if (group) {
      group.querySelectorAll('button[data-option-index]').forEach(b => b.classList.remove('on'));
      btn.classList.add('on');
    }

    const idx = parseInt(btn.dataset.optionIndex, 10);
    const val = btn.dataset.value;
    window._selectedOptions[idx] = val;

    // Populate any un-selected options with first visible "on" button
    document.querySelectorAll('[data-option-index]').forEach(b => {
      const i = parseInt(b.dataset.optionIndex, 10);
      if (!(i in window._selectedOptions) && b.classList.contains('on')) {
        window._selectedOptions[i] = b.dataset.value;
      }
    });

    matchVariant();
  };

  function matchVariant() {
    if (!window.productVariants) return;
    const opts = window._selectedOptions;
    const matched = window.productVariants.find(v => {
      return v.options.every((o, i) => !opts.hasOwnProperty(i) || opts[i] === o);
    });

    if (matched) {
      // Update ATC button variant id
      const atcBtn = document.getElementById('atc-btn');
      if (atcBtn) atcBtn.dataset.variantId = matched.id;

      // Update displayed price
      const priceEl = document.getElementById('prod-price');
      const stickyPrice = document.getElementById('sticky-price');
      if (priceEl || stickyPrice) {
        const formatted = formatMoney(matched.price);
        if (priceEl) priceEl.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = formatted;
      }

      // Availability — update ATC button AND out-of-stock paragraph
      const ooMsg = document.getElementById('out-of-stock-msg');
      if (atcBtn) {
        const label = atcBtn.querySelector('.atc-label');
        if (!matched.available) {
          atcBtn.disabled = true;
          if (label) label.textContent = 'Rupture de stock';
          if (ooMsg) ooMsg.style.display = '';
        } else {
          atcBtn.disabled = false;
          if (label) label.textContent = 'Ajouter au panier';
          if (ooMsg) ooMsg.style.display = 'none';
        }
      }

      // Update gallery image when variant has its own featured_media
      const mainImg = document.getElementById('gal-img');
      if (mainImg && matched.featured_media && matched.featured_media.preview_image) {
        const variantImgSrc = matched.featured_media.preview_image.src;
        if (variantImgSrc) {
          // Append Shopify CDN width param for correct resolution
          const sep = variantImgSrc.includes('?') ? '&' : '?';
          mainImg.src = variantImgSrc + sep + 'width=800';
        }
      }
    }
  }

  // Seed selected options from the initially-active buttons, then sync UI state
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('button[data-option-index].on').forEach(b => {
      const i = parseInt(b.dataset.optionIndex, 10);
      window._selectedOptions[i] = b.dataset.value;
    });
    matchVariant(); // Ensure price, variant ID and availability reflect the pre-selected options
  });
})();


/* ─── 5. Money formatter ────────────────────────────────────── */
function formatMoney(cents) {
  if (window.moneyFormat) {
    // Use Shopify money format
    const amount = (cents / 100).toFixed(2);
    return window.moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }
  return (cents / 100).toFixed(2) + ' €';
}


/* ─── 6. Cart state ─────────────────────────────────────────── */
let _cart = { items: [], item_count: 0, total_price: 0 };

function fetchCart() {
  return fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      _cart = cart;
      updateCartUI();
      return cart;
    })
    .catch(err => console.error('[P&C] fetchCart error:', err));
}


/* ─── 7. Add to cart ────────────────────────────────────────── */
window.addToCart = function (btn) {
  if (!btn) return;
  const variantId = parseInt(btn.dataset.variantId, 10);
  if (!variantId) {
    console.warn('[P&C] No variant ID on ATC button');
    return;
  }

  const label = btn.querySelector('.atc-label');
  const added = btn.querySelector('.atc-added');
  btn.disabled = true;
  if (label) label.hidden = true;
  if (added) added.hidden = false;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(r => {
      if (!r.ok) return r.json().then(e => { throw e; });
      return r.json();
    })
    .then(() => fetchCart())
    .then(() => {
      setTimeout(() => {
        btn.disabled = false;
        if (label) { label.textContent = 'Ajouter au panier'; label.hidden = false; }
        if (added) added.hidden = true;
        openCart();
      }, 800);
    })
    .catch(err => {
      console.error('[P&C] Add to cart error:', err);
      btn.disabled = false;
      if (label) { label.hidden = false; }
      if (added) { added.hidden = true; }
      const msg = err.description || err.message || 'Erreur lors de l\'ajout au panier.';
      alert(msg);
    });
};


/* ─── 8. Cart drawer open / close ───────────────────────────── */
window.openCart = function () {
  fetchCart().then(() => {
    const drawer  = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (drawer)  { drawer.classList.add('open');  drawer.setAttribute('aria-hidden', 'false'); }
    if (overlay) { overlay.classList.add('open'); }
    document.body.style.overflow = 'hidden';
  });
};

window.closeCart = function () {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (drawer)  { drawer.classList.remove('open');  drawer.setAttribute('aria-hidden', 'true'); }
  if (overlay) { overlay.classList.remove('open'); }
  document.body.style.overflow = '';
};


/* ─── 9. Update cart quantity ───────────────────────────────── */
window.updateLineItem = function (key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then(r => r.json())
    .then(cart => {
      _cart = cart;
      updateCartUI();
    })
    .catch(err => console.error('[P&C] updateLineItem error:', err));
};


/* ─── 10. Render cart UI ────────────────────────────────────── */
function updateCartUI() {
  const itemsEl   = document.getElementById('cartItems');
  const emptyEl   = document.getElementById('cartEmpty');
  const footerEl  = document.getElementById('cartFooter');
  const countEl   = document.getElementById('cartCount');
  const subtotalEl = document.getElementById('cartSubtotal');

  if (countEl) {
    const count = _cart.item_count || 0;
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'inline-flex' : 'none';
  }

  if (!itemsEl) return;

  const items = _cart.items || [];

  if (items.length === 0) {
    itemsEl.innerHTML = '';
    if (emptyEl)  emptyEl.hidden  = false;
    if (footerEl) footerEl.hidden = true;
    return;
  }

  if (emptyEl)  emptyEl.hidden  = true;
  if (footerEl) footerEl.hidden = false;

  if (subtotalEl) subtotalEl.textContent = formatMoney(_cart.total_price);

  itemsEl.innerHTML = items.map(item => {
    const imgSrc = item.image
      ? item.image.replace(/(\.\w+)$/, '_160x160$1')
      : '';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span class="cart-item-variant">${item.variant_title}</span>`
      : '';
    return `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-img"
             src="${imgSrc}"
             alt="${item.title}"
             loading="lazy"
             width="72" height="72">
        <div class="cart-item-info">
          <span class="cart-item-title">${item.product_title}</span>
          ${variantTitle}
          <div class="cart-item-qty">
            <button class="qty-btn"
                    aria-label="Diminuer la quantité"
                    onclick="updateLineItem('${item.key}', ${item.quantity - 1})">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn"
                    aria-label="Augmenter la quantité"
                    onclick="updateLineItem('${item.key}', ${item.quantity + 1})">+</button>
          </div>
        </div>
        <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
      </div>`;
  }).join('');
}


/* ─── 11. FAQ accordion ─────────────────────────────────────── */
window.faqTgl = function (btn) {
  const item = btn.closest('.faq-item');
  if (!item) return;
  const isOpen = item.classList.contains('open');

  // Close all other open items in the same list (optional: remove to allow multiple open)
  // Uncomment the block below to make it exclusive:
  // const list = item.closest('.faq-list, .faq-items');
  // if (list) list.querySelectorAll('.faq-item.open').forEach(other => {
  //   if (other !== item) {
  //     other.classList.remove('open');
  //     const ob = other.querySelector('.faq-q');
  //     if (ob) ob.setAttribute('aria-expanded', 'false');
  //   }
  // });

  item.classList.toggle('open', !isOpen);
  btn.setAttribute('aria-expanded', String(!isOpen));
};


/* ─── 12. Sticky ATC — IntersectionObserver ─────────────────── */
(function initStickyAtc() {
  const sAtc   = document.getElementById('sAtc');
  const atcBtn = document.getElementById('atc-btn');
  if (!sAtc || !atcBtn) return;

  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        sAtc.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }
})();


/* ─── 13. Newsletter (native Shopify form handles submit) ─── */
// No custom JS needed — Shopify's {% form 'customer' %} posts to /contact natively.
// We add a small enhancement for UX feedback if the form is present.
(function initNewsletter() {
  const form = document.getElementById('nl-form-shopify');
  if (!form) return;
  form.addEventListener('submit', function () {
    const btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'ENVOI…';
    }
  });
})();


/* ─── 14. On page load — fetch cart count ───────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  fetchCart();
});
